import requestFunctions from "../../functions/requestFunctions";


export const state = {
  ASSORTMENTS_ITEM: {},
  ASSORTMENTS_LIST: [],
  ASSORTMENTS_TABLE_DATA: [],
  ASSORTMENTS_ARRAY_DATA: [],
  ASSORTMENTS_TOTAL_ROWS: 0
}

export const getters = {
  GET_ASSORTMENTS_ITEM: (state) => {
    return state.ASSORTMENTS_ITEM;
  },
  GET_ASSORTMENTS_LIST: (state) => {
    return state.ASSORTMENTS_LIST;
  },
  GET_ASSORTMENTS_TABLE_DATA: (state) => {
    return state.ASSORTMENTS_TABLE_DATA;
  },
  GET_ASSORTMENTS_ARRAY_DATA: (state) => {
    return state.ASSORTMENTS_ARRAY_DATA;
  },
  GET_ASSORTMENTS_TOTAL_ROWS: (state) => {
    return state.ASSORTMENTS_TOTAL_ROWS;
  }
}

export const mutations = {

  UPDATE_ASSORTMENTS_ITEM(state, item) {
    state.ASSORTMENTS_ITEM = item;
  },

  UPDATE_ASSORTMENTS_LIST(state, list) {
    
    state.ASSORTMENTS_LIST = list.data;

    state.ASSORTMENTS_TOTAL_ROWS = list.total;
    list = list.data;
    
    state.ASSORTMENTS_TABLE_DATA = [];
    state.ASSORTMENTS_ARRAY_DATA = [];

    list.forEach(el => {

      state.ASSORTMENTS_TABLE_DATA.push({
        'uuid' : el.uuid,
        'id' : el.id,
        'product_article_number' : el.product_article_number,
        'product_code' : el.product_code,
        'product_name' : el.product_name,
        'brand_name' : el.brand_name,
        'product_buy_cost' : el.product_buy_cost,
        'marketplace_name' : el.marketplace_name,
        'cost' : el.cost,
        'comments' : el.comments,
        'created_at' : el.created_at,
        'updated_at' : el.updated_at,
        'product_category_name': el.product_category_name,
      });

      state.ASSORTMENTS_ARRAY_DATA.push({
        id: el.id,
        uuid: el.uuid,
        name: el.name,
      });
    });
  },
}

export const actions = {

  async FETCH_ASSORTMENTS_ITEM({ commit }, payload) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/assortments/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_ASSORTMENTS_ITEM', response.data);
      return response.data;
    }
  },

  async FETCH_ASSORTMENTS_LIST({ commit }, payload= {}) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/assortments';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_ASSORTMENTS_LIST', response.data);
      return response.data;
    }
  },

  async FETCH_ASSORTMENTS_CREATE({ commit }, payload) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/assortments';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'POST');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },

  async FETCH_ASSORTMENTS_UPDATE({ commit }, payload) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/assortments/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'PUT');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },

  async FETCH_ASSORTMENTS_DELETE({ commit }, payload) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/assortments/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'DELETE');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },
}